import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_cf_messages_sequence_RowClass } from "../../../dbschema";

export class BotCfMessagesSequenceContainerModel extends BaseContainerModel{
  alg_bot_cf_messages_sequence: alg_bot_cf_messages_sequence_RowClass = new alg_bot_cf_messages_sequence_RowClass();
}
